module.exports = __webpack_public_path__ + "img/tjdlr.a5aa95f5.png";